import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getAccessToken } from '@/utils/token.utils';
import { useAuth } from '@/hooks/auth.hooks';

const ProtectedRoute: React.FC = () => {
  const navigate = useNavigate();
  const { isRestoring } = useAuth();

  useEffect(() => {
    if (!isRestoring && !getAccessToken()) {
      navigate('/login');
    }
  }, [isRestoring, navigate]);

  if (isRestoring) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
